import { morphism } from 'morphism';
import { createStrictSchema, createUnknownSchema } from '../../utils/morph.js';

const regionSchema = createStrictSchema({
    uri: () => '/geo/region',
    id: 'key',
    value: 'value',
    friendlyName: 'friendly_name',
    label: 'label',
    level: 'level',
    neighbors: 'neighbors',
});
const regionReverseSchema = createUnknownSchema({
    uri: () => '/geo/region',
    id: 'key',
    value: 'value',
    friendly_name: 'friendlyName',
    label: 'label',
    level: 'level',
    neighbors: 'neighbors',
});
const regionsSchema = createStrictSchema({
    regions: {
        path: 'values',
        fn: morphism(regionSchema),
    },
});
const citySchema = createStrictSchema({
    uri: () => '/geo/city',
    id: 'key',
    value: 'value',
    label: 'label',
    level: 'level',
    friendlyName: 'friendly_name',
    istat: 'istat',
    regionId: 'region_id',
    shortName: 'short_name',
});
const cityReverseSchema = createUnknownSchema({
    uri: () => '/geo/city',
    id: 'key',
    value: 'value',
    label: 'label',
    level: 'level',
    friendly_name: 'friendlyName',
    istat: 'istat',
    region_id: 'regionId',
    short_name: 'shortName',
});
const townSchema = createStrictSchema({
    uri: () => '/geo/town',
    id: 'key',
    value: 'value',
    label: 'label',
    level: 'level',
    friendlyName: 'friendly_name',
    istat: 'istat',
    cityId: 'city_id',
    hasZone: 'has_zone',
    regionId: 'region_id',
});
const townReverseSchema = createUnknownSchema({
    uri: () => '/geo/town',
    id: 'key',
    value: 'value',
    label: 'label',
    level: 'level',
    friendly_name: 'friendlyName',
    istat: 'istat',
    city_id: 'cityId',
    has_zone: 'hasZone',
    region_id: 'regionId',
});
const zoneSchema = createStrictSchema({
    uri: () => '/geo/zone',
    id: 'key',
    value: 'value',
    label: 'label',
    level: 'level',
    cityId: 'city_id',
    regionId: 'region_id',
    townId: 'town_id',
});
const zipCodeSchema = createStrictSchema({
    zipCode: 'zip_code',
    town: 'town',
    province: 'province',
});
const zipCodesSchema = (body) => Array.isArray(body) ? body.map(morphism(zipCodeSchema)) : [];
const mapSchema = createStrictSchema({
    address: 'address',
    latitude: 'latitude',
    longitude: 'longitude',
    zoom: 'zoom',
    showPin: {
        path: 'show_pin',
        // the non-strict equal is intentional
        fn: (showPin) => showPin == '1',
    },
});
const itemGeoSchema = createStrictSchema({
    uri: 'uri',
    type: 'type',
    label: 'label',
    region: {
        path: 'region',
        fn: morphism(regionSchema),
    },
    city: {
        path: 'city',
        fn: morphism(citySchema),
    },
    town: {
        path: 'town',
        fn: morphism(townSchema),
    },
    map: {
        path: 'map',
        fn: morphism(mapSchema),
    },
});
const zonesSchema = createStrictSchema({
    zones: {
        path: 'values',
        fn: morphism(zoneSchema),
    },
});
const geoEntrySchema = createStrictSchema({
    region: {
        path: 'region',
        fn: morphism(regionSchema),
    },
    city: {
        path: 'city',
        fn: morphism(citySchema),
    },
    town: {
        path: 'town',
        fn: morphism(townSchema),
    },
});
const geoEntryReverseSchema = createUnknownSchema({
    region: {
        path: 'region',
        fn: morphism(regionReverseSchema),
    },
    city: {
        path: 'city',
        fn: morphism(cityReverseSchema),
    },
    town: {
        path: 'town',
        fn: morphism(townReverseSchema),
    },
});
const geoEntriesSchema = createStrictSchema({
    entries: {
        path: 'data',
        fn: morphism(geoEntrySchema),
    },
});

export { cityReverseSchema, citySchema, geoEntriesSchema, geoEntryReverseSchema, geoEntrySchema, itemGeoSchema, regionsSchema, townReverseSchema, townSchema, zipCodesSchema, zoneSchema, zonesSchema };
//# sourceMappingURL=morph.js.map
